import stAsset from './asset.component';
import stAssetCommitments from './assetCommitments.component';
import stAssetCommitmentSchedules from './assetCommitmentSchedules.component';
import stAssets from './assets.component';
import assetsService from './assets.service';
import stContact from './contact.component';
import stExpenses from './expenses.component';
import expensesService from './expenses.service';
import factFindController from './factFind.controller';
import helperService from './helper.service';
import stHouseholdExpenses from './householdExpenses.component';
import stHouseholds from './households.component';
import householdsService from './households.service';
import stIncome from './income.component';
import incomeService from './income.service';
import stIncomes from './incomes.component';
import stInsurance from './insurance.component';
import stInsurances from './insurances.component';
import insurancesService from './insurances.service';
import stLiabilities from './liabilities.component';
import liabilitiesService from './liabilities.service';
import stLiability from './liability.component';
import stMentor from './mentor.component';
import stMergeDocuments from './mergeDocuments.component';
import stNeedsAndObjectives from './needsAndObjectives.component';
import needsAndObjectivesService from './needsAndObjectives.service';
import stNeedsAndObjectivesBankruptcy from './needsAndObjectivesBankruptcy.component';
import stObjectives from './objectives.component';
import stOtherAdviser from './otherAdviser.component';
import stOtherAdvisers from './otherAdvisers.component';
import otherAdvisersService from './otherAdvisers.service';
import stProductRequirements from './productRequirements.component';

export default angular
  .module('st.FactFind', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .component('stAsset', stAsset)
  .component('stAssetCommitments', stAssetCommitments)
  .component('stAssetCommitmentSchedules', stAssetCommitmentSchedules)
  .component('stAssets', stAssets)
  .service('assetsService', assetsService)
  .component('stContact', stContact)
  .component('stExpenses', stExpenses)
  .service('expensesService', expensesService)
  .controller('factFindController', factFindController)
  .service('helperService', helperService)
  .component('stHouseholdExpenses', stHouseholdExpenses)
  .component('stHouseholds', stHouseholds)
  .service('householdsService', householdsService)
  .component('stIncome', stIncome)
  .service('incomeService', incomeService)
  .component('stIncomes', stIncomes)
  .component('stInsurance', stInsurance)
  .component('stInsurances', stInsurances)
  .service('insurancesService', insurancesService)
  .component('stLiabilities', stLiabilities)
  .service('liabilitiesService', liabilitiesService)
  .component('stLiability', stLiability)
  .component('stMentor', stMentor)
  .component('stMergeDocuments', stMergeDocuments)
  .component('stNeedsAndObjectives', stNeedsAndObjectives)
  .service('needsAndObjectivesService', needsAndObjectivesService)
  .component('stNeedsAndObjectivesBankruptcy', stNeedsAndObjectivesBankruptcy)
  .component('stObjectives', stObjectives)
  .component('stOtherAdviser', stOtherAdviser)
  .component('stOtherAdvisers', stOtherAdvisers)
  .service('otherAdvisersService', otherAdvisersService)
  .component('stProductRequirements', stProductRequirements);
